import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';
import {ToasterService, Toast} from 'angular2-toaster';

@Injectable()
export class ErrorService {

  constructor(private http: Http, private toasterService: ToasterService) { }

  saveError(error: any): Promise<any> {
    return this.http.post('/api/error/', error)
      .toPromise()
      .then(res => {
        return res;
      })
      .catch(err => {
        const toast : Toast = {
            type: 'error',
            title: err.statusText,
            body: err.status + ' - ' + err.statusText ,
            timeout: 15000
        };
        this.toasterService.pop(toast);
      });
  }
}
